import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { LIST_PAGE_COUNT } from '../../data/common';
import TablePaginationActions from '../TablePaginationActions';
import { map } from 'lodash';
import BonusProductQRCodeTableRow from './BonusProductQRCodeTableRow';

const BonusProductQRCodeTable = (props) => {
  const { QRCodes, total, page, setPage, isLoading, downloadQRCode } = props;

  return (
    <TableContainer component={Box}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>商品</TableCell>
            <TableCell>套券</TableCell>
            <TableCell>序號</TableCell>
            <TableCell>代銷</TableCell>
            <TableCell>狀態</TableCell>
            <TableCell>歸戶</TableCell>
            <TableCell>歸戶時間</TableCell>
            <TableCell>歸戶員工</TableCell>
            <TableCell>使用會員</TableCell>
            <TableCell>使用時間</TableCell>
            <TableCell>使用員工</TableCell>
            <TableCell>建立時間</TableCell>
            <TableCell>建立員工</TableCell>
            <TableCell align="right">功能</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {QRCodes &&
            map(QRCodes, (QRCode) => {
              return (
                <BonusProductQRCodeTableRow
                  key={QRCode.bonusProductQRCodeId}
                  QRCode={QRCode}
                  isLoading={isLoading}
                  downloadQRCode={downloadQRCode}
                />
              );
            })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[LIST_PAGE_COUNT]}
              colSpan={15}
              count={total}
              rowsPerPage={LIST_PAGE_COUNT}
              page={page - 1}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={(event, currentPage) => {
                setPage(currentPage + 1);
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default BonusProductQRCodeTable;
